export const TABLET_BREAKPOINT = 900;

/** Mobile vs desktop layout variant shared across responsive components. */
export const LAYOUT_VARIANT = {
  MOBILE: 'mobile',
  DESKTOP: 'desktop',
} as const;

export type LayoutVariant =
  (typeof LAYOUT_VARIANT)[keyof typeof LAYOUT_VARIANT];

/** Main site header (desktop + mobile); matches society public search chrome
 *  row height AND the landing page's floating chrome (HomeFloatingChrome), so
 *  navigating `/` ⇄ `/search` ⇄ `/registry` never changes the bar height. */
export const NAV_HEIGHT = 64;
export const SIDEBAR_WIDTH = 240;
export const SIDEBAR_WIDTH_COLLAPSED = 64;
export const PAGE_PADDING = 24;
export const PAGE_PADDING_MOBILE = 12;
export const PAGE_PADDING_MOBILE_PUBLIC = 20;
export const PAGE_PADDING_TOP = 12;
export const HEADER_HEIGHT = 12 + 32 + 12;
export const HEADER_CONFIGURATION_HEIGHT = 12 + 56 + 12;
export const HEADER_SUB_PAGE_HEIGHT = 20 + 56 + 20 + 1 + 12;
export const TABLE_BOTTOM_PADDING = 12;
export const FOOTER_HEIGHT = 40;
export const MOBILE_FOOTER_HEIGHT = 36;

/** Height of the public animal detail tab bar: 72px for the tabs themselves,
 *  the 1px `borderBottom` under them, and the 16px `mb: 2` below that. The 72
 *  is MUI's `minHeight` for a `Tab` carrying both an icon and a label — not
 *  the 48px `Tabs` default — and every tab in that bar has both.
 *
 *  Only an estimate for first paint: `AnimalDetailView` measures the real bar
 *  and passes the result down, because this number can't see the page padding
 *  above the bar and silently drifts if a tab ever loses its icon. */
export const ANIMAL_TAB_BAR_HEIGHT = 72 + 1 + 16;
export const Z_INDEX = {
  appBar: 1100,
  drawer: 1200,
  fab: 1050,
  mobileStepper: 1000,
  modal: 1300,
  snackbar: 1400,
  speedDial: 1050,
  tooltip: 1500,
};
